import { Controller } from "@hotwired/stimulus"

// Converts dollar input to cents for form submission
// Usage:
//   <div data-controller="price-input">
//     <input type="text" data-price-input-target="dollars" data-action="input->price-input#convert">
//     <input type="hidden" data-price-input-target="cents" name="model[price_cents]">
//   </div>
export default class extends Controller {
  static targets = ["dollars", "cents"]

  connect() {
    this.convert()
  }

  convert() {
    if (!this.hasDollarsTarget || !this.hasCentsTarget) return

    const dollars = parseFloat(this.dollarsTarget.value) || 0
    const cents = Math.round(dollars * 100)
    this.centsTarget.value = cents
  }
}
